import React from 'react';

const SvgCu = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="CU_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="CU_svg__b" fill="#fff">
        <use xlinkHref="#CU_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path
        fill="#0B389F"
        mask="url(#CU_svg__b)"
        d="M0 0h28v4H0zM0 8h28v4H0zM0 16h28v4H0z"
      />
      <path fill="#E12A43" mask="url(#CU_svg__b)" d="M0 0l13.333 10L0 20z" />
      <path
        fill="#FFF"
        mask="url(#CU_svg__b)"
        d="M4.667 11.023l-1.568 1.134.595-1.841-1.563-1.14 1.935-.003.6-1.84.602 1.84 1.935.003-1.564 1.14.595 1.841z"
      />
    </g>
  </svg>
);

export default SvgCu;
